import { queryOptions, useQuery } from '@tanstack/react-query';

import { ordersApi } from '../api/orders-api';

import { orderKeys } from './order-keys';

export function orderQueryOptions(storeId: string, id: string) {
  return queryOptions({
    queryKey: orderKeys.detail(storeId, id),
    queryFn: () => ordersApi.get(storeId, id),
  });
}

export function useOrder(storeId: string, id: string) {
  return useQuery(orderQueryOptions(storeId, id));
}
